"use client";

// lib/use-double-tap.ts
// Shared double-tap detection, extracted from name-card-pager.tsx's NavButton
// (same 350ms threshold). Returns a single click handler: a tap within 350ms
// of the previous one fires onDoubleTap instead of onTap.

import { useRef } from "react";

export function useDoubleTap(onTap: () => void, onDoubleTap: () => void) {
  const lastTap = useRef<number>(0);
  return function handleTap() {
    const now = Date.now();
    if (now - lastTap.current < 350) {
      lastTap.current = 0;
      onDoubleTap();
    } else {
      lastTap.current = now;
      onTap();
    }
  };
}
